import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import Avatar from 'shared-components/Avatar/Avatar';
import styles from './TeamAvatars.module.css';

const TeamAvatars = ({ list, className, context }) => {
  const listSize = _.size(list);
  const longList = listSize > 4;
  const displayedList = longList ? _.slice(list, 0, 3) : list;

  return (
    <div
      className={classNames(styles.container, className, {
        [styles[context]]: context,
      })}
    >
      {_.map(displayedList, (item) => {
        const { userAvatarUrl, userId, username } = item;
        return (
          <Avatar
            key={userId}
            className={styles.avatar}
            url={userAvatarUrl}
            alt={username}
          />
        );
      })}
      {longList && (
        <div className={classNames(styles.avatar, styles.plus)}>
          {`+${listSize - _.size(displayedList)}`}
        </div>
      )}
    </div>
  );
};

TeamAvatars.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      userAvatarUrl: PropTypes.string,
      userId: PropTypes.number,
      username: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
  context: PropTypes.string,
};

TeamAvatars.defaultProps = {
  className: null,
  context: null,
};

export default TeamAvatars;
